import { formatReportDateUnix, stripMarkdown } from "@entities/history";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { ReportOperationsProps } from "./types";
import classes from "./report-operations.module.scss";

export const ReportOperations = ({ events, isPdfMode }: ReportOperationsProps) => {
    return events.length === 0 ? (
        <div className={classes.operations__empty}>История эксплуатации отсутствует</div>
    ) : (
        <div className={classes.operations}>
            <ul className={classes.operations__list}>
                {events.map((item, index) => {
                    const title = (
                        <div className={classes.operations__header}>
                            {item.event}
                            <div className={classes.operations__date}>
                                {formatReportDateUnix(item.date)}
                            </div>
                        </div>
                    );

                    const content = (
                        <div
                            className={classes.operations__content}
                            dangerouslySetInnerHTML={{
                                __html: stripMarkdown(item.description)
                            }}
                        />
                    );

                    return (
                        <li key={index} className={classes.operations__item}>
                            <div className={classes.operations__line} />
                            <div className={classes.operations__point} />
                            {item.description ? (
                                <FixedAccordion
                                    expanded={isPdfMode}
                                    title={title}
                                    content={content}
                                />
                            ) : (
                                title
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};